import {
  Box,
  Button,
  Paper,
  Tooltip,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { ImageField, Loading, useShowController } from "react-admin";
import { useRef, useState } from "react";

import AdjustDialog from "../customer-insight/members/AdjustDialog";
import ReceiptDialog from "../payment/payment-success/ReceiptDialog";
import SfBreadcrumbs from "../../components/SfBreadcrumbs";
import VoidDialog from "../customer-insight/members/VoidDialog";
import moment from "moment";
import useCheckPermissionHook from "../../hooks/useCheckPermissionHook";
import useEditTransaction from "../../hooks/useEditTransaction";
import useOneBranch from "../../hooks/useOneBranch";
import useOneUser from "../../hooks/useOneUser";
import useSFAlert from "../../hooks/useSFAlert";

//import useBranches from "../../hooks/useBranches";

//import useSFSuccess from "../../hooks/useSFSuccess";

const useStyles = makeStyles((theme) => ({
  allContainer: {
    padding: 30,
    boxSizing: "border-box",
    position: "absolute",
    overflow: "auto",
    top: 0,
    bottom: 0,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  breadcrumbs: {
    alignSelf: "flex-start",
  },

  buttonContainer: {
    marginTop: 20,
    width: "100%",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, 300px)",
    justifyItems: "center",
    justifyContent: "center",
  },
  button: {
    width: 200,
    height: 50,
    fontSize: 22,
  },
  void: {
    backgroundColor: theme.red,
    color: theme.white,
  },
  adjust: {
    backgroundColor: theme.darkGray,
    color: theme.white,
  },
  itemListGrid: {
    display: "grid",
    gridTemplateColumns: "33% 33% 34%",
    gridAutoRows: "auto",
    width: "400px",
    justifyContent: "center",
  },
  otherListGrid: {
    display: "grid",
    gridTemplateColumns: "50% 50%",
    gridAutoRows: "auto",
    width: "400px",
    justifyContent: "center",
  },
  twoColumnsGrid: {
    display: "grid",
    gridTemplateColumns: "50% 50%",
    gridAutoRows: "auto",
    width: "400px",
  },
  headerText: {
    fontWeight: "bolder",
  },
  image: {
    //width: "300px",
    minHeight: "auto",
    maxWidth: "720px",
    maxHeight: "1280px",
    width: "auto",
    height: "auto",
  },
  input: {
    display: "none",
  },
}));

// const StyledBox = withStyles((theme) => ({
//   root: {
//     borderRadius: 20,
//     boxSizing: "border-box",
//     marginTop: 20,
//     backgroundColor: theme.lightOrange,
//     padding: 12,
//   },
// }))(Box);

const useStyleBox = makeStyles((theme) => ({
  root: {
    borderRadius: 20,
    boxSizing: "border-box",
    marginBottom: 10,
    backgroundColor: theme.lightGray,
    padding: 12,
    display: "grid",
    placeItems: "center",
    width: 680,
  },
  title: {},
}));
const StyledBox = ({ title, children }) => {
  const classes = useStyleBox();
  return (
    <>
      <Typography align="center" variant={"h6"}>
        {title}
      </Typography>
      <Box className={classes.root}>{children}</Box>
    </>
  );
};

const RecordRow = ({ label, value }) => {
  return (
    <>
      <Typography align="left">{label}</Typography>
      <Typography align="right">{value}</Typography>
    </>
  );
};

const BranchRow = ({ label, value }) => {
  const { branch, loading, error } = useOneBranch(value);
  return (
    <>
      <Typography align="left">{label}</Typography>
      <Typography align="right">
        {loading ? "Loading" : error ? "Error" : branch.name}
      </Typography>
    </>
  );
};

const UserRow = ({ label, value }) => {
  const { user, loading, error } = useOneUser(value);
  return (
    <>
      <Typography align="left">{label}</Typography>
      <Typography align="right">
        {loading
          ? "Loading"
          : error
          ? "Error"
          : user.firstname + " " + user.lastname}
      </Typography>
    </>
  );
};

// const ReferenceRecordRow = ({
//   label,
//   record,
//   source,
//   reference,
//   basePath,
//   refSource,
// }) => {
//   return (
//     <>
//       <Typography align="left">{label}</Typography>
//       <ReferenceField
//         record={record}
//         source={source}
//         reference={reference}
//         basePath={basePath}
//         link={false}
//       >
//         <TextField align="right" source={refSource} />
//       </ReferenceField>
//     </>
//   );
// };
/*
<ReferenceField
        record={record}
        source={"member.id"}
        reference="members"
        basePath="members"
      >
        <TextField source="firstname_en" />
      </ReferenceField>
*/

export const TransactionShow = (props) => {
  const classes = useStyles();
  const { editTransaction } = useEditTransaction();
  const input = useRef();
  const [showVoidDialog, setShowVoidDialog] = useState(false);
  const [showAdjustDialog, setShowAdjustDialog] = useState(false);
  const [showReceiptDialog, setShowReceiptDialog] = useState(false);
  const [alert] = useSFAlert();
  //const [success] = useSFSuccess(window.location.reload);
  const {
    loading, // boolean that is true on mount, and false once the record was fetched
    record, // record fetched via dataProvider.getOne() based on the id from the location
  } = useShowController(props);
  const { loading: permissionLoading, allow } = useCheckPermissionHook({
    code: "Page.Merchant.Management.Payment_History",
    write: true,
  });
  if (loading || permissionLoading) return <Loading />;

  const handleCapture = async (file) => {
    //setSelectedFile(target.files[0]);
    const [, error] = await editTransaction({
      id: record.id,
      version: record.__v,
      image: file,
    });
    if (error) {
      alert(error);
    } else window.location.reload();
  };

  return (
    <Paper className={classes.allContainer}>
      <SfBreadcrumbs
        className={classes.breadcrumbs}
        path="Management/Transactions/View"
      />
      <Typography align="center" variant="h2">
        Transaction
      </Typography>
      {!record.member.firstname ? (
        <StyledBox title={"Customer Information"} className={classes.box}>
          <Box className={classes.twoColumnsGrid}>
            <Typography variant="h5">Guest</Typography>
            <Typography variant="h5"></Typography>
            <RecordRow label="Gender" value={record.guest?.gender} />
            <RecordRow label="Age" value={record.guest?.age} />
            <RecordRow
              label="hashTags"
              value={
                record.guest?.hashtags ? String(record.guest?.hashtags) : ""
              }
            />
          </Box>
        </StyledBox>
      ) : (
        <StyledBox title="Customer Information">
          <Box className={classes.twoColumnsGrid}>
            <Typography variant="h5">Member</Typography>
            <Typography variant="h5"></Typography>
            <RecordRow label="Firstname" value={record.member.firstname} />
            <RecordRow label="Lastname" value={record.member.lastname} />
          </Box>
        </StyledBox>
      )}

      <StyledBox title="Products">
        <Box className={classes.itemListGrid}>
          <Typography align="left" className={classes.headerText}>
            Name
          </Typography>
          <Typography align="center" className={classes.headerText}>
            QTY
          </Typography>
          <Typography align="right" className={classes.headerText}>
            THB
          </Typography>
          {record.bill_detail?.map((bill) => {
            if (bill.item_type !== "product") return null;
            return (
              <>
                <Typography align="left">{bill.product_name}</Typography>
                <Typography align="center">{bill.qty}</Typography>
                <Typography align="right">{bill.paid_amount}</Typography>
              </>
            );
          })}
        </Box>
      </StyledBox>

      <StyledBox title="Others">
        <Box className={classes.otherListGrid}>
          {record.bill_detail?.map((bill) => {
            if (bill.item_type === "product") return null;
            if (bill.item_type === "offer")
              return bill.coupons.map((coupon) => {
                if (coupon.type === "discount") {
                  return (
                    <>
                      <Typography align="left">Discount</Typography>
                      <Typography align="right">
                        {coupon.discount_percent
                          ? `${coupon.discount_percent}% (${coupon.discount_amount} THB)`
                          : `${coupon.discount_amount} (THB)`}
                      </Typography>
                    </>
                  );
                }
                return (
                  <>
                    <Typography align="left">{"Earn"}</Typography>
                    <Typography align="right">{coupon.logic}</Typography>
                  </>
                );
              });
            if (bill.item_type === "discount")
              return (
                <>
                  <Typography align="left">{"Point as Cash"}</Typography>
                  <Typography align="right">{`${bill.discount_amount} (THB)`}</Typography>
                </>
              );
            return (
              <>
                <Typography align="left">{bill.event_code}</Typography>
                <Typography align="right">{""}</Typography>
              </>
            );
          })}
        </Box>
      </StyledBox>
      <StyledBox title="Delivery">
        <Box className={classes.twoColumnsGrid}>
          <RecordRow label="Delivery Cost" value={record.delivery_cost} />
        </Box>
      </StyledBox>

      <StyledBox title="Summary (Excluding Delivery Cost)">
        <Box className={classes.twoColumnsGrid}>
          <RecordRow label="Transaction no." value={record.transaction_no} />
          <RecordRow label="Total Payment" value={record.total_payment} />
          <RecordRow label="Total QTY" value={record.total_qty} />
          <RecordRow label="Total Revenue" value={record.total_revenue} />
          <RecordRow label="Total Discount" value={record.total_discount} />
          <RecordRow
            label="Total Points"
            value={
              Object.values(record.earn).reduce(
                (total, cur) => total + cur,
                0
              ) ?? 0
            }
          />
          <RecordRow
            label="Transaction date"
            value={moment(record.create_local_time).format("DD MMM YY HH:mm")}
          />
          <UserRow label="By" value={record.create_by_id} />
          <BranchRow label="Branch" value={record.branch_id} />
        </Box>
      </StyledBox>

      <StyledBox title="Payment Methods (Excluding Delivery Cost)">
        <Box className={classes.twoColumnsGrid}>
          <Typography align="left" className={classes.headerText}>
            Type
          </Typography>
          <Typography align="right" className={classes.headerText}>
            THB
          </Typography>
          {record.payment_channels?.map((channel) => {
            return (
              <>
                <Typography align="left">{channel.type}</Typography>
                <Typography align="right">{channel.amount}</Typography>
              </>
            );
          })}
        </Box>
      </StyledBox>
      <StyledBox title="Image">
        <ImageField
          record={record}
          source="slip_image_url"
          title="Attach file"
          classes={{
            image: classes.image,
          }}
        />
        <Box>
          <input
            ref={input}
            accept="image/*"
            className={classes.input}
            type="file"
            onChange={(e) => handleCapture(e.target.files[0])}
          />
          <Tooltip title="Upload Image">
            <label htmlFor="faceImage">
              <Button
                color="primary"
                variant="contained"
                onClick={() => input.current.click()}
              >
                Upload
              </Button>
            </label>
          </Tooltip>
        </Box>
      </StyledBox>
      <StyledBox title="remark">
        <Typography variant="body">{record.remark}</Typography>
      </StyledBox>
      <StyledBox title="Receipt">
        <Button
          variant="contained"
          color="primary"
          onClick={() => setShowReceiptDialog(true)}
        >
          View
        </Button>
      </StyledBox>
      {record.status === "Void" ? null : (
        <>
          <Box className={classes.buttonContainer}>
            <Button
              className={[classes.button, classes.void]}
              variant="contained"
              onClick={() => setShowVoidDialog(true)}
              disabled={!allow}
            >
              Void
            </Button>
            {record.member?.firstname ? (
              <Button
                className={[classes.button, classes.adjust]}
                variant="contained"
                onClick={() => setShowAdjustDialog(true)}
                disabled={!allow}
              >
                Adjust
              </Button>
            ) : null}
          </Box>
          <VoidDialog
            open={showVoidDialog}
            onClose={() => {
              setShowVoidDialog(false);
              window.location.reload();
            }}
            memberId={record["member"]?.id}
            transactionNo={record["transaction_no"]}
            version={record.__v}
          />
          <AdjustDialog
            open={showAdjustDialog}
            onClose={() => {
              setShowAdjustDialog(false);
              window.location.reload();
            }}
            memberId={record["member"]?.id}
            transactionNo={record["transaction_no"]}
            existingPoint={record.earn?.reward}
            version={record.__v}
          />
        </>
      )}
      <ReceiptDialog
        open={showReceiptDialog}
        isCI={true}
        onClose={() => setShowReceiptDialog(false)}
        receipt={{ id: record.transaction_no, date: record.time }}
        payment={{
          paymentChannels: record.payment_channels,
          member: record.member,
        }}
        paymentTransaction={{
          items: record.bill_detail,
          tier_name: "",
          branchId: record.branch_id,
          staffId: record.create_by_id,
          deliveryCost: record.delivery_cost ?? 0,
          summary: {
            total_discount: record.total_discount,
            total_payment: record.total_payment,
            total_revenue: record.total_revenue,
            earn_amount: record.earn?.reward,
          },
        }}
      />
    </Paper>
  );
};
